import { PropsWithChildren } from 'react';
import { motion } from 'framer-motion';

const container = {
  hidden: { opacity: 0, y: 8 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.25, ease: 'easeOut' } },
};

export default function PageFade({ children }: PropsWithChildren) {
  return (
    <motion.div initial="hidden" animate="visible" variants={container}>
      {children}
    </motion.div>
  );
}

